/**
 * Como se nombra y se describe un producto en pantalla.
 */

/**
 * "Traje de Neopreno 3 mm Bandu · Talla M".
 *
 * Las tallas de un mismo producto comparten nombre (VAR-01). En la ficha eso
 * esta bien —la talla la dice el selector—, pero en el carro, en el resumen del
 * pedido y en un mensaje de WhatsApp el nombre solo no dice cual se eligio.
 */
export function nombreConVariante(producto: {
  nombre: string;
  etiquetaVariante: string | null;
}): string {
  return producto.etiquetaVariante !== null
    ? `${producto.nombre} · ${producto.etiquetaVariante}`
    : producto.nombre;
}

export interface Especificacion {
  campo: string;
  valor: string;
}

/**
 * La ficha tecnica se guarda como texto, una especificacion por linea y con la
 * forma `Campo: valor`. Es lo que el administrador puede escribir en un cuadro
 * de texto sin aprender nada. Una linea sin dos puntos no se pierde: entra como
 * "Detalle".
 */
export function especificacionesDe(fichaTecnica: string | null): Especificacion[] {
  if (fichaTecnica === null) return [];

  return fichaTecnica
    .split('\n')
    .map((linea) => linea.trim())
    .filter((linea) => linea.length > 0)
    .map((linea) => {
      const corte = linea.indexOf(':');
      if (corte <= 0) return { campo: 'Detalle', valor: linea };

      return { campo: linea.slice(0, corte).trim(), valor: linea.slice(corte + 1).trim() };
    })
    .filter((especificacion) => especificacion.valor.length > 0);
}
